import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import App from './App';
import { startWebVitalsCapture } from './posthogClient';

// PostHog: init once at root, pass client to provider (per https://posthog.com/docs/libraries/react)
const posthogKey = process.env.REACT_APP_POSTHOG_TOKEN;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
const enableAnalytics =
  process.env.REACT_APP_ENABLE_ANALYTICS === 'true' ||
  process.env.REACT_APP_ENABLE_ANALYTICS === undefined;

if (posthogKey && enableAnalytics) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    persistence: 'localStorage',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    defaults: '2026-01-30',
    // Debug: logs every event and errors to console (useful for troubleshooting)
    debug: process.env.NODE_ENV === 'development',
  });
  startWebVitalsCapture();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </Router>
  </React.StrictMode>
);

//================================================================
// Register service worker for PWA capabilities 
// serviceWorker.register(); // This line caused ReferenceError

// Standard service worker registration logic
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then(registration => {
      })
      .catch(error => {
      });
  });
}
